import { ErrorComponent } from '@openx/components-core/lib/Error/Error.tsx';
import { FailureImage } from '@openx/components-core/lib/Error/pictures/Failure.tsx';
import { FullLoader } from '@openx/components-core/lib/Loader/FullLoader.tsx';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../api/queryKeys.ts';
import { useAuth } from '../components/AuthContext.tsx';
import { fetchInstancesListResponse } from '../utils/fetchInstancesListResponse.ts';
import { useLogout } from '../utils/useLogout.ts';
import { InstanceSelectForm } from './InstanceSelectForm.tsx';

export const InstanceSelectPage = () => {
  const { currentUser } = useAuth();
  const { logout } = useLogout();

  const {
    data: instancesList,
    isLoading,
    error,
  } = useQuery({
    meta: {
      errorMessage: 'Failed to fetch instance list',
    },
    queryFn: async () => {
      const response = await fetchInstancesListResponse({ currentUser });

      if (response.error) {
        throw response.error;
      }

      return response.instancesList;
    },
    queryKey: [QueryKeys.LOGIN_APP_INSTANCE_LIST, currentUser?.uid],
    retry: false,
  });

  if (error) {
    return (
      <ErrorComponent
        title="Authorization error"
        subtitle={`Something went wrong while attempting to sign you in: ${error.message}`}
        PictureComponent={FailureImage}
        data-test="authorization-error"
        actions={[
          {
            children: 'Log out',
            color: 'secondary',
            'data-test': 'button-log-in',
            onClick: logout,
            variant: 'contained',
          },
        ]}
      />
    );
  }

  if (isLoading || !instancesList) {
    return <FullLoader />;
  }

  return <InstanceSelectForm instancesList={instancesList} onLogout={logout} />;
};
